import { STORAGE_KEY } from "@constants";
import { getMemberSettings } from "@utils/member-settings";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import bengaliTranslation from "./locales/bn.json";
import englishTranslation from "./locales/en.json";
import spanishTranslation from "./locales/es.json";
import hindiTranslation from "./locales/hi.json";
import indonesiaTranslation from "./locales/id.json";
import portugueseTranslation from "./locales/pt.json";
import thailandTranslation from "./locales/th.json";
import tagalogTranslation from "./locales/tl.json";
import urduTranslation from "./locales/ur.json";
import { PersistLanguage } from "./plugins";

const resources = {
  en: {
    translation: englishTranslation,
  },
  th: {
    translation: thailandTranslation,
  },
  id: {
    translation: indonesiaTranslation,
  },
  bn: {
    translation: bengaliTranslation,
  },
  ur: {
    translation: urduTranslation,
  },
  tl: {
    translation: tagalogTranslation,
  },
  es: {
    translation: spanishTranslation,
  },
  pt: {
    translation: portugueseTranslation,
  },
  hi: {
    translation: hindiTranslation,
  },
};

i18next.use(PersistLanguage).use(initReactI18next);

export const initI18n = (lng?: string) => {
  i18next.init({
    resources,
    lng,
    debug: false,
  });
};

const memberSettings = getMemberSettings();

const lng =
  localStorage.getItem(STORAGE_KEY.LANGUAGE) ?? (memberSettings?.isLoaded ? memberSettings.language : undefined);

initI18n(lng);

export default i18next;
